import React from 'react';
import PropTypes from 'prop-types';
import { Spring } from 'react-spring/renderprops';
import NumberFormat from 'react-number-format';

import './styles.css';
import {usePrevious} from '../../../../hooks/usePrevious';

const FeedPostSocial = props => {
  const { onLike, onComment, likes, likesCount, commentsCount } = props;

  const onClickLikeIcon = (e) => {
    onLike();
  };

  const onClickCommentIcon = () => {
    onComment();
  };

  const likesCountRef = usePrevious(Number(likesCount) || 0);
  const commentsCountRef = usePrevious(Number(commentsCount) || 0);

  return (
    <div className="feed-post-social">
      <div
          className="feed-post-social__control"
          onClick={onClickLikeIcon}
      >
        <span className="feed-post-social__icon feed-post-social__icon--like" />
        <span className="feed-post-social__counter">
          (
          <Spring
            from={{ value: likesCountRef }}
            to={{ value: Number(likesCount) }}
          >
            {props => (
              <NumberFormat
                thousandSeparator
                value={props.value.toFixed(0)}
                displayType={'text'}
              />
            )}
          </Spring>
          )
        </span>
        {likes && likes.length > 0 && (
          <div className="feed-post-social__tooltip">
            <div
                className="feed-post-social__tooltip-content"
                >
              <ul className="feed-post-social__tooltip-list">
                {likes.map((like, index) => (
                  <li
                    key={index}
                    className="feed-post-social__tooltip-list-item"
                  >
                    <span className="feed-post-social__tooltip-link">
                      {like.FullName}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
      <div className="feed-post-social__control feed-post-social__control--comment">
        <span
          className="feed-post-social__icon feed-post-social__icon--comment"
          onClick={onClickCommentIcon}
        />
        <span
          onClick={onClickCommentIcon}
          className="feed-post-social__counter"
        >
          (
          <Spring
            from={{ value: commentsCountRef }}
            to={{ value: Number(commentsCount) }}
          >
            {props => (
              <NumberFormat
                thousandSeparator
                value={props.value.toFixed(0)}
                displayType={'text'}
              />
            )}
          </Spring>
          )
        </span>
      </div>
    </div>
  );
};

FeedPostSocial.defaultProps = {
  onClickLikeIconHandler: () => {},
};

FeedPostSocial.propTypes = {
  onClickLikeIconHandler: PropTypes.func,
};

export default FeedPostSocial;
